import type { ReactNode } from 'react'

import { Dialog, Button } from '@atoms'
import type { IconTypes } from '@components/utils/Icon'

import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('components.confirm_dialog')

type ConfirmDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  body?: string
  confirmLabel: string
  onConfirm: () => void
  confirmColor?: 'danger' | 'primary'
  confirmIcon?: IconTypes
  busy?: boolean
  children?: ReactNode
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  body,
  confirmLabel,
  onConfirm,
  confirmColor = 'danger',
  confirmIcon,
  busy = false,
  children,
}: ConfirmDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content size="lg">
        <Dialog.Header>
          <Dialog.Title>{title}</Dialog.Title>
          {body && <Dialog.Description className="tw:text-gray-600">{body}</Dialog.Description>}
        </Dialog.Header>
        {children}
        <Dialog.Footer className="tw:mt-2 tw:gap-2">
          <Dialog.Close asChild>
            <Button rank="secondary" disabled={busy}>
              {t('cancel')}
            </Button>
          </Dialog.Close>
          <Button
            rank="primary"
            color={confirmColor}
            disabled={busy}
            {...(confirmIcon ? { leadingIcon: confirmIcon } : {})}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
